import { useQuery } from '@tanstack/react-query';

import { ME_QUERY } from '../graphql/queries';
import { gql } from '../lib/api';

interface CurrentUser {
  role: 'viewer' | 'admin';
}

export const useUserGroups = (): string[] => {
  const { data } = useQuery({
    queryKey: ['current-user'],
    queryFn: () => gql<{ me: CurrentUser }>(ME_QUERY),
  });

  return data?.me.role === 'admin' ? ['viewer', 'admin'] : ['viewer'];
};
